/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import './src/styles/css/bootstrap.min.css';
import "./src/styles/css/animate.min.css"
import "./src/styles/css/boxicons.min.css"
import "./src/styles/css/flaticon.css"
import 'react-accessible-accordion/dist/fancy-example.css'
import 'react-18-image-lightbox/style.css';
import "/node_modules/aos/dist/aos.css";
import "swiper/css"
import "swiper/css/bundle"

// Global style
import "./src/styles/css/style.css" 
import "./src/styles/css/responsive.css" 


import "./src/styles/css/dbpasn.scss"
import "./src/styles/css/dbpasn-responsive.scss"
import "./src/styles/css/beyond-academics.scss"

export const onRouteUpdate = ({ location }) => {
  if (location.hash) return // respect anchor links

  requestAnimationFrame(() => {
    const pageBanner = document.querySelector('.page-title-area')
    if (pageBanner) {
      const bannerBottom = pageBanner.getBoundingClientRect().bottom + window.scrollY
      window.scrollTo({ top: bannerBottom, behavior: 'instant' })
    }
  })
}